import { createSlice } from '@reduxjs/toolkit';
import { getCookie } from 'utils/commonFunctions';
import config from 'utils/config';

let initialState = {
  isUserLoggedIn: (getCookie(config.gameCookieName)?.guid && true) || false
};
const loginSlice = createSlice({
  name: 'login',
  initialState: initialState,
  reducers: {
    setUserLoggedIn: (state, action) => {
      return { ...state, isUserLoggedIn: !state?.isUserLoggedIn };
    },
    resetCreateTeamReduxState: (state, action) => {
      return initialState;
    }
  }
});

export const { setUserLoggedIn, resetCreateTeamReduxState } = loginSlice.actions;
export default loginSlice.reducer;
